import "@dxos/node-std/globals"
import {
  AuthExtension,
  AuthStatus,
  DataPipeline,
  DataServiceHost,
  DataServiceImpl,
  DataServiceSubscriptions,
  DatabaseHost,
  MOCK_AUTH_PROVIDER,
  MOCK_AUTH_VERIFIER,
  MetadataStore,
  Pipeline,
  STORAGE_VERSION,
  SnapshotManager,
  SnapshotStore,
  Space,
  SpaceManager,
  SpaceProtocol,
  SpaceProtocolSession,
  TimeframeClock,
  codec,
  createMappedFeedWriter,
  mapFeedIndexesToTimeframe,
  mapTimeframeToFeedIndexes,
  spaceGenesis,
  startAfter,
  valueEncoding
} from "./chunk-4TOOIHMA.mjs";

// packages/core/echo/echo-pipeline/src/errors/errors.ts
var DBError = class extends Error {
  constructor(code, message, context) {
    super(message ? `${code}: ${message}` : code.toString());
    this.code = code;
    this.context = context;
    Object.setPrototypeOf(this, new.target.prototype);
  }
};
var IdentityNotInitializedError = class extends DBError {
  constructor() {
    super("IDENTITY_NOT_INITIALIZED", "Identity not initialized.");
  }
};
var InvalidInvitationError = class extends DBError {
  constructor() {
    super("INVALID_INVITATION", "Invitation is invalid.");
  }
};
var InvalidStorageVersionError = class extends DBError {
  constructor(expected, actual) {
    super("INVALID_STORAGE_VERSION", "Invalid storage version.", {
      expected,
      actual
    });
  }
};
var SpaceNotFoundError = class extends DBError {
  constructor(spaceKey) {
    super("SPACE_NOT_FOUND", "Space not found.", {
      spaceKey
    });
  }
};
var EntityNotFoundError = class extends DBError {
  constructor(entityId) {
    super("ITEM_NOT_FOUND", "Item not found.", {
      entityId
    });
  }
};
var UnknownModelError = class extends DBError {
  constructor(model) {
    super("UNKNOWN_MODEL", "Unknown model.", {
      model
    });
  }
};
export {
  AuthExtension,
  AuthStatus,
  DBError,
  DataPipeline,
  DataServiceHost,
  DataServiceImpl,
  DataServiceSubscriptions,
  DatabaseHost,
  EntityNotFoundError,
  IdentityNotInitializedError,
  InvalidInvitationError,
  InvalidStorageVersionError,
  MOCK_AUTH_PROVIDER,
  MOCK_AUTH_VERIFIER,
  MetadataStore,
  Pipeline,
  STORAGE_VERSION,
  SnapshotManager,
  SnapshotStore,
  Space,
  SpaceManager,
  SpaceNotFoundError,
  SpaceProtocol,
  SpaceProtocolSession,
  TimeframeClock,
  UnknownModelError,
  codec,
  createMappedFeedWriter,
  mapFeedIndexesToTimeframe,
  mapTimeframeToFeedIndexes,
  spaceGenesis,
  startAfter,
  valueEncoding
};
//# sourceMappingURL=index.mjs.map
